import { isMobile } from '@/utils'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function responsiveRoute({ mobile, desktop }) {
  return isMobile() ? mobile : desktop
}

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'works' }
    },
    {
      path: '/works/:workId?/:resultId?',
      name: 'works',
      component: responsiveRoute({
        mobile: () =>
          import(
            /* webpackChunkName: "works-mobile" */ '@/views/WorksMobile.vue'
          ),
        desktop: () =>
          import(
            /* webpackChunkName: "works-desktop" */ '@/views/WorksDesktop.vue'
          )
      })
    },
    {
      path: '/works/:workId/full/:resultId',
      name: 'result-full',
      component: () =>
        import(/* webpackChunkName: "result-full" */ '@/views/ResultFull.vue'),
      meta: {
        showNavigation: false
      }
    },
    {
      path: '/:page',
      name: 'page',
      component: () => import(/* webpackChunkName: "page" */ './views/Page.vue')
    }
  ]
})

router.afterEach(to => {
  document.title = to.meta.title || document.title
})

export default router
